import request from '@/router/axios';

let urlPrefix = '/api/lab/labraceexpuserreport';

export const editRaceExpUserReport = data => {
    const { id } = data;
    let type = id ? 'put' : 'post';
    return request(urlPrefix, { data }, type);
};

// 学生的竞赛报告

/**
 * 分配竞赛题目
 * @param {Object} data
 * @param {String} data.answer 学生提交的报告信息
 * @param {String} data.expUid 竞赛实验uid
 * @param {String} data.groupUid 小组uid
 * @param {Time} data.markTime 批阅时间
 * @param {String} data.report 报告题目信息
 * @param {Number} data.score 得分
 * @param {Number} data.status 状态   0 未提交  1 未批改  2 已评分
 * @param {Time} data.submitTime 报告提交时间
 * @param {String} data.userId 成员id
 */
export const addLabRaceExpUserReport = data => {
    return request(`${urlPrefix}/distribute`, { data }, 'post');
};

/**
 * 学生提交报告
 * @param {String} uid 学生实验记录uid
 * @param {String} data 答案 params
 */
export const submitRaceExpUserReport = data => {
    return request(`${urlPrefix}/submit`, { data }, 'post');
};

/**
 * 获取战队报告
 * @param {Object} params 入参
 * @param {String} params.uid 实验项目UID
 * @param {String} params.groupUid 战队UID
 */
export const getRaceExpGroupReport = params => {
    return request(`${urlPrefix}/report`, { params });
};

/**
 * 获取学生竞赛实验报告详情
 * @param {String} uid 
 */
export const getRaceExpUserReportDetail = uid => {
    return request(`${urlPrefix}/${uid}/detail`);
};

export const putLabraceexpuserreport = data => {
    return request(`${urlPrefix}`, { data }, 'put');
};